import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import SharedCard from './components/SharedCard';
import classNames from 'classnames';

const skeletonObj = {
  id: 1,
  title: 'Texto de propiedad',
  address: `Texto para la dirección`,
  barrios: 'Texto para el barrio',
  price: 'Texto para el precio',
  expenses: 'Texto para las expensas',
  operation: `Operacion`,
  updated_at: 'Texto para la fecha',
  created_at: 'Texto para la fecha',
  type: 'Texto para el tipo',
  locality: 'Texto para la localidad',
  characteristics: {
    ambience: 10,
    bedrooms: 10,
    bathrooms: 10,
    toilettes: 10,
    garages: 10,
    floors: 10
  },
  share: {
    active: true,
    percent: 50
  },
  surface: 'Texto para la superficie',
  real_estate: {
    name: 'Texto para la inmobiliaria',
    branchOffice: [
      {
        id: 1,
        branch_office_name: 'Texto para Sucursal',
        isCentral: false,
        isActive: true,
        phoneNumber: '1234567890',
        openingHours: 'Texto para el horario',
        address: 'Texto para la dirección'
      }
    ]
  }
};

const SharedCards = ({
  projects,
  loading,
  propsLimit,
  selected,
  setSelected
}) => {
  const skeletonArr = Array(propsLimit).fill(skeletonObj);

  return (
    <Row
      className={classNames('g-2', {
        'loading-skeleton': loading
      })}
    >
      {!loading
        ? projects.map(project => (
            <Col key={project.id} xs={12} sm={6} xxl={4}>
              <SharedCard
                proj={project}
                selected={selected}
                setSelected={setSelected}
              />
            </Col>
          ))
        : skeletonArr.map((project, index) => (
            <Col key={index} xs={12} sm={6} xxl={4}>
              <SharedCard proj={project} loading />
            </Col>
          ))}
    </Row>
  );
};

SharedCards.propTypes = {
  projects: PropTypes.array,
  loading: PropTypes.bool,
  propsLimit: PropTypes.number.isRequired,
  selected: PropTypes.array,
  setSelected: PropTypes.func
};

export default SharedCards;
